var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"text"},domProps:{"value":_vm.option[_vm.objKey]},on:{"input":function($event){return _vm.$emit('changed', $event.target.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }